module.exports = __webpack_public_path__ + "static/img/watermark_ktiebao@2x.d5a156d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/activity/KtbPlatformInfoMin/watermark_ktiebao@2x.png
// module id = Waan
// module chunks = 69